import React from 'react'
import { createContext } from 'use-context-selector'
import { useAppContextState } from 'app/@hooks'

const Context = createContext({})
// `isSwitching` is flipped on by the toggle and forces the root table component
// to render <TableLoading /> for one tick — gives the browser time to paint the
// spinner before the heavy pivot/non-pivot model recompute blocks the main thread.
const initialState = { isPivot: false, isSwitching: false }

export function PackagesPivotProvider({ children }) {
    const { state, replaceState, updateState } = useAppContextState(initialState)
    return <Context.Provider value={{ state, replaceState, updateState }}>{children}</Context.Provider>
}

export default Context
